import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { AllLocales, Locale, detectLocaleClientSide } from '@global/locale/Locale'

const ns = ['common']

const getInitialLanguage = (): Locale | 'cimode' => {
  if (typeof window === 'undefined') {
    return 'en'
  }

  const searchParams = new URLSearchParams(window.location.search)

  if (searchParams.get('phrase')) {
    return 'cimode'
  }

  const preferredLanguage = searchParams.get('lang')
  if (preferredLanguage && AllLocales.includes(preferredLanguage as Locale)) {
    return preferredLanguage as Locale
  }

  const detected = detectLocaleClientSide()
  if (detected && AllLocales.includes(detected as Locale)) {
    return detected as Locale
  }

  return 'en'
}

export const initialLanguage = getInitialLanguage()

const i18nDebug = import.meta.env.VITE_NO_I18N_DEBUG === 'true' ? false : import.meta.env.DEV

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: i18nDebug,
    lng: initialLanguage,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    defaultNS: ns[0],
    ns,
    supportedLngs: AllLocales,
    returnNull: false,
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    react: { useSuspense: true },
  })

export default i18n
